import { SectionHeader } from "./shared";
import chevronRight from "../../assets/home/chevron-right.svg";

const STEPS = [
  { title: "Apply Online", desc: "Submit your application through the digital application experience." },
  { title: "Complete Verification", desc: "Complete the required verification and assessment process." },
  { title: "Receive the Lender's Decision", desc: "Your application is reviewed based on the applicable eligibility and assessment criteria." },
];

export default function HomeHowItWorks() {
  return (
    <section className="bg-white px-4 sm:px-6 lg:px-[80px] py-[60px]">
      <div className="max-w-[1280px] mx-auto">
        <div className="lg:min-h-[155px]">
          <SectionHeader
            badge="Workflow"
            title="How It Works"
            subtitle="Getting started with FastRupees involves a digital process. Here are the three main steps."
          />
        </div>
        <div className="mt-8 lg:mt-0 grid grid-cols-1 md:grid-cols-3 gap-4">
          {STEPS.map((step, i) => (
            <div key={step.title} className="flex flex-col gap-4 bg-[#f7f4ff] border border-[#f3f4f6] rounded-[24px] p-6">
              <div className="flex items-center justify-between">
                <span className="font-black text-[#5c168a] text-[32px]">{String(i + 1).padStart(2, "0")}</span>
                {i < STEPS.length - 1 && <img alt="" src={chevronRight} className="size-[18px]" />}
              </div>
              <p className="font-bold text-[#1a1a4b] text-[16px]">{step.title}</p>
              <p className="text-[#6a7282] text-[13px] leading-[18px]">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
